import { useQuery } from "@tanstack/react-query";

import { getTelegramSettings } from "@/api/settings";
import { SettingsQueryKeys } from "./settingsQueryKeys";

export const useTelegramSettings = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [SettingsQueryKeys.Telegram],
    queryFn: ({ signal }) => getTelegramSettings({ signal }),
    enabled: options?.enabled,
  });
};
